export const createLinearRampToValueAutomationEvent = (value, endTime) => {
    return { endTime, type: 'linearRampToValue', value };
};
//# sourceMappingURL=create-linear-ramp-to-value-automation-event.js.map